import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

class SummaryRowByYear extends Component {

    renderSummaryCells() {
        const { columns, source } = this.props;
        return _.map(
            columns,
            column => {
                if(column.sum) {
                    return <td key={column.dataIndex}>
                        {/* {_.sumBy(source, item => parseFloat(item[column.dataIndex]))} */}
                        {source[0] && source[0][column.dataIndex]}
                    </td>
                };
                return <td key={column.dataIndex}></td>
            }
        )
    }
    
    render() { 
        return <tr className={'vt-table-summary vt-table-summary-year'}>
            {this.renderSummaryCells()}
        </tr>
    }
};

export default SummaryRowByYear;
// const mapStateToProps = (state) => {
//     const { source } = state.buhtable;
//     return {
//         source: source,
//     }
// };
 
// export default connect(mapStateToProps)(SummaryRowByYear);



// WEBPACK FOOTER //
// ./src/components/VirtualTable/SummaryRowByYear.jsx